module.exports = __webpack_public_path__ + "img/calendar-check-fill.d66cf9c0.svg";